module.exports = __webpack_public_path__ + "img/logo-spotify.b0a5df30.svg";